import React from 'react'
import cx from 'classnames'
import { useDevice } from 'device'
import { useIsApplePayAvailable } from 'modules/payment'

import { Icon } from 'components/dataDisplay'

import PayPalButton from './components/PayPalButton/PayPalButton'
import AmazonPayButton from './components/AmazonPayButton/AmazonPayButton'
import ExpressCheckoutButton from './components/ExpressCheckoutButton/ExpressCheckoutButton'
import ApplePayButton from './components/ApplePayButton/ApplePayButton'


type ExpressCheckoutProps = {
  className?: string
  disabled?: boolean
}

const ExpressCheckout: React.FunctionComponent<ExpressCheckoutProps> = (props) => {
  const { className, disabled } = props

  const { isMobile } = useDevice()
  const isApplePayAvailable = useIsApplePayAvailable()

  return (
    <div className={cx(className, 'grid gap-16', isMobile ? 'grid-cols-1' : (isApplePayAvailable ? 'grid-cols-3' : 'grid-cols-2'))}>
      {
        disabled ? (
          <>
            {/* If disabled we show placeholder buttons, because otherwise it's very difficult to disable Amazon button  */}
            <ExpressCheckoutButton disabled data-testid="paypalButton">
              <Icon className="opacity-50" name="other/paypal" />
            </ExpressCheckoutButton>
            <ExpressCheckoutButton disabled data-testid="amazonPayButton">
              <Icon className="pt-8 opacity-50" name="other/amazon" isInline />
            </ExpressCheckoutButton>
            {
              isApplePayAvailable && (
                <ExpressCheckoutButton disabled data-testid="applePayButton">
                  <Icon className="pt-8 opacity-50" name="other/apple-pay" isInline />
                </ExpressCheckoutButton>
              )
            }
          </>
        ) : (
          <>
            <PayPalButton />
            <AmazonPayButton />
            {
              isApplePayAvailable && (
                <ApplePayButton />
              )
            }
          </>
        )
      }
    </div>
  )
}


export default ExpressCheckout
